// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-module--logo--2KMYz","words":"Logo-module--words--s2DVD"};